import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';

const FabBottom = ({handleClick})=> {
  return (
    <Fab 
      color="primary" 
      aria-label="add" 
      sx={{ position: 'fixed', bottom: 60, right: 40 }}
      onClick={()=>(handleClick("data"))}
    >
      <AddIcon />
    </Fab>
  );
}

export default FabBottom